import { render, staticRenderFns } from "./2Roues.vue?vue&type=template&id=4a6698a3&"
import script from "./2Roues.vue?vue&type=script&lang=js&"
export * from "./2Roues.vue?vue&type=script&lang=js&"
import style0 from "./2Roues.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports